"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetFolderViewUpdate = exports.assetFolderViewSuccess = exports.assetFolderViewReset = exports.assetFolderViewParentList = exports.assetFolderViewList = exports.assetFolderViewInitialListChangeReset = exports.assetFolderViewInitialListChange = exports.assetFolderViewInitialList = exports.assetFolderViewError = exports.assetFolderViewDelete = exports.assetFolderViewAdd = exports.assetFolderView = exports.assetAccessPermisionUpdate = exports.assetAccessPermisionFetch = exports.assetAccessPermisionAdd = void 0;
var _assetFolderView = require("./assetFolderView.constant");
// @flow

// common success
var assetFolderViewSuccess = function assetFolderViewSuccess(actionType, data) {
  return {
    type: _assetFolderView.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.assetFolderViewSuccess = assetFolderViewSuccess;
var assetFolderViewError = function assetFolderViewError(actionType, error) {
  return {
    type: _assetFolderView.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add asset folder.
 */
exports.assetFolderViewError = assetFolderViewError;
var assetFolderViewAdd = function assetFolderViewAdd(data) {
  return {
    type: _assetFolderView.actionTypes.ADD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update asset folder.
 */
exports.assetFolderViewAdd = assetFolderViewAdd;
var assetFolderViewUpdate = function assetFolderViewUpdate(data) {
  return {
    type: _assetFolderView.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * get asset folder list
 * @param payload
 * @returns api response
 * @description this function used to get asset folder list.
 */
exports.assetFolderViewUpdate = assetFolderViewUpdate;
var assetFolderViewList = function assetFolderViewList(data) {
  return {
    type: _assetFolderView.actionTypes.VIEW_LIST,
    payload: data
  };
};

/**
 * get asset folder parent list
 * @param payload
 * @returns api response
 * @description this function used to get asset folder parent list.
 */
exports.assetFolderViewList = assetFolderViewList;
var assetFolderViewParentList = function assetFolderViewParentList(data) {
  return {
    type: _assetFolderView.actionTypes.PARENT_LIST,
    payload: data
  };
};

/**
 * get asset folder initial list
 * @param payload
 * @returns api response
 * @description this function used to get asset folder initial list.
 */
exports.assetFolderViewParentList = assetFolderViewParentList;
var assetFolderViewInitialList = function assetFolderViewInitialList(data) {
  return {
    type: _assetFolderView.actionTypes.INITIAL_LIST,
    payload: data
  };
};

/**
 * get asset folder initial list
 * @param payload
 * @returns api response
 * @description this function used to get asset folder initial list.
 */
exports.assetFolderViewInitialList = assetFolderViewInitialList;
var assetFolderViewInitialListChange = function assetFolderViewInitialListChange(data) {
  return {
    type: _assetFolderView.actionTypes.INITIAL_LIST_CHANGE,
    payload: data
  };
};

/**
 * get asset folder initial list reset
 * @param payload
 * @returns api response
 * @description this function used to get asset folder initial list.
 */
exports.assetFolderViewInitialListChange = assetFolderViewInitialListChange;
var assetFolderViewInitialListChangeReset = function assetFolderViewInitialListChangeReset() {
  return {
    type: _assetFolderView.actionTypes.INITIAL_LIST_CHANGE_RESET
  };
};

/**
 * Delete
 * @param payload
 * @returns api response
 * @description this function used to get asset folder Delete.
 */
exports.assetFolderViewInitialListChangeReset = assetFolderViewInitialListChangeReset;
var assetFolderViewDelete = function assetFolderViewDelete(data) {
  return {
    type: _assetFolderView.actionTypes.DELETE,
    payload: data
  };
};

/**
 * get asset folder
 * @param payload
 * @returns api response
 * @description this function used to get asset folder.
 */
exports.assetFolderViewDelete = assetFolderViewDelete;
var assetFolderView = function assetFolderView(data) {
  return {
    type: _assetFolderView.actionTypes.FETCH,
    payload: data
  };
};

/**
 * update asset access permission
 * @param payload
 * @returns api response
 * @description this function used to update asset access permission.
 */
exports.assetFolderView = assetFolderView;
var assetAccessPermisionUpdate = function assetAccessPermisionUpdate(data) {
  return {
    type: _assetFolderView.actionTypes.UPDATE_ASSET_PERMISSION,
    payload: data
  };
};

/**
 * add asset access permission
 * @param payload
 * @returns api response
 * @description this function used to add asset access permission.
 */
exports.assetAccessPermisionUpdate = assetAccessPermisionUpdate;
var assetAccessPermisionAdd = function assetAccessPermisionAdd(data) {
  return {
    type: _assetFolderView.actionTypes.ADD_ASSET_PERMISSION,
    payload: data
  };
};

/**
 * get asset access permission
 * @param payload
 * @returns api response
 * @description this function used to get asset access permission.
 */
exports.assetAccessPermisionAdd = assetAccessPermisionAdd;
var assetAccessPermisionFetch = function assetAccessPermisionFetch(data) {
  return {
    type: _assetFolderView.actionTypes.FETCH_ASSET_PERMISSION,
    payload: data
  };
};

/**
 * reset asset folder
 * @param payload
 * @returns api response
 * @description this function used to reset asset folder view.
 */
exports.assetAccessPermisionFetch = assetAccessPermisionFetch;
var assetFolderViewReset = function assetFolderViewReset() {
  return {
    type: _assetFolderView.actionTypes.RESET
  };
};
exports.assetFolderViewReset = assetFolderViewReset;